import { Text, ActivityItem, DetailsRow, GroupedList, GroupHeader, IActivityItemProps, IActivityItemStyles, IColumn, IconButton, IDetailsRowStyles, IGroup, IGroupHeaderProps, IGroupRenderProps, IIconProps, mergeStyleSets, SelectionMode, TooltipHost, Tooltip, Shimmer } from '@fluentui/react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import axios, { CancelTokenSource } from 'axios';
import * as React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import pecmailService from '../../../../../services/pecmail.service';
import protocolDispatchesService from '../../../../../services/protocolDispatches.service';
import { ProtocolDispatchEF_Status, ProtocolDispatchEF_Status_Label, StatoRicevutaEnum, StatoRicevutaLabel, TipoDestinatarioEnum, TipoDestinatarioLabel, TipoRicevutaEnum } from '../../../../../shared/enums';
import { IProtocol, IProtocolDispatch, IStatoRicevutaPecMail } from '../../../../../shared/interfaces';
import Utilities from '../../../../../shared/Utilities/utilities';
import { RootState } from '../../../../../store';
import { toastRef } from '../../../../Layout/Layout';
import CircleLoader from '../../../../Loader/CircleLoader/CircleLoader';
import { myTheme } from '../../../../../assets/styles/my-theme';


// Tipo UI locale
interface IStatoRicevutaItem extends IStatoRicevutaPecMail {
    spedizioneId: number;
    mailbox: string;
    placeholder?: string | undefined;
}


const { palette } = myTheme;

const downloadIcon: IIconProps = { iconName: 'Download' };

let classNames = mergeStyleSets({
    padding: {
        paddingBottom: '3px',
        paddingTop: '3px'
    },
    headerMargins: {
        marginTop: '20px'
    },
    columnWidth: {
        width: '200px'
    },
    overflow: {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    statoLabel: {
        marginRight: '4px',
        fontWeight: 'bold'
    },
    statoColorRed: {
        color: "rgb(232, 12, 12)"
    },
    statoColorGreen: {
        color: "rgb(79, 173, 60)"
    },
    statoColorYellow: {
        color: "rgb(213 163 12)"
    },
    accettazione: {
        marginTop: '5px',
        color: "rgb(79, 173, 60)",
        fontWeight: 'bold'
    },
    tipoDestinatarioColor: {
        color: "#0ea5e9"
    }

});

const activityItemStyles: IActivityItemStyles = {
    root: {
        overflow: 'hidden'
    },
    activityContent: {
        overflow: 'hidden'
    },
    activityText: {
        overflow: 'hidden'
    },
    timeStamp: {
        overflow: 'hidden'
    }
}

const detailsRowStyles: Partial<IDetailsRowStyles> = {
    root: {
        display: 'flex',
        width: '100%',
        flex: 1,

        '& .ms-DetailsRow-fields': {
            width: '100%'
        },
        '& .ms-DetailsRow-cell:first-child': {
            flex: '1 1 auto'
        },
        '& .ms-DetailsRow-cell:nth-child(2)': {
            flex: '0 0 auto'
        }
    }
}

const tipoDestinatarioIconTooltipMap: Record<TipoDestinatarioEnum, { iconProps: FontAwesomeIconProps; tooltip: string }> = {
    [TipoDestinatarioEnum.NonDefinito]: {
        iconProps: {
            className: classNames.tipoDestinatarioColor,
            icon: { prefix: 'fal', iconName: 'notdef' },
            style: { marginRight: "5px" }
        },
        tooltip: ''
    },
    [TipoDestinatarioEnum.Certificato]: {
        iconProps: {
            className: classNames.tipoDestinatarioColor,
            icon: { prefix: 'fal', iconName: 'award' },
            style: { marginRight: "5px" }
        },
        tooltip: 'Destinatario PEC (posta certificata)'
    },
    [TipoDestinatarioEnum.Esterno]: {
        iconProps: {
            className: classNames.tipoDestinatarioColor,
            icon: { prefix: 'fal', iconName: 'user' },
            style: { marginRight: "5px" }
        },
        tooltip: 'Destinatario di posta ordinaria'
    }
};

const statoRicevutaIconTooltipMap: Record<StatoRicevutaEnum, { statoColorCss: string; statoRicevutaLabel: string }> = {
    [StatoRicevutaEnum.InAttesa]: { statoColorCss: `${classNames.statoLabel}  ${classNames.statoColorYellow}`, statoRicevutaLabel: 'In attesa' },
    [StatoRicevutaEnum.Accettato]: { statoColorCss: `${classNames.statoLabel} ${classNames.statoColorGreen}`, statoRicevutaLabel: 'Accettata' },
    [StatoRicevutaEnum.NonAccettato]: { statoColorCss: `${classNames.statoLabel}  ${classNames.statoColorRed}`, statoRicevutaLabel: 'Non accettata' },
    [StatoRicevutaEnum.PresaInCarico]: { statoColorCss: `${classNames.statoLabel}  ${classNames.statoColorYellow}`, statoRicevutaLabel: 'Presa in carico' },
    [StatoRicevutaEnum.PreavvisoErroreConsegna]: { statoColorCss: `${classNames.statoLabel}  ${classNames.statoColorYellow}`, statoRicevutaLabel: 'Preavviso errore consegna' },
    [StatoRicevutaEnum.RilevazioneVirus]: { statoColorCss: `${classNames.statoLabel}  ${classNames.statoColorRed}`, statoRicevutaLabel: 'Rilevazione virus' },
    [StatoRicevutaEnum.Consegna]: { statoColorCss: `${classNames.statoLabel} ${classNames.statoColorGreen}`, statoRicevutaLabel: 'Consegnata' },
    [StatoRicevutaEnum.MancataConsegna]: { statoColorCss: `${classNames.statoLabel}  ${classNames.statoColorRed}`, statoRicevutaLabel: 'Mancata consegna' },

};

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUor: state.sessionReducer.currentUor,
    currentUser: state.sessionReducer.currentUser,
})
const mapDispatch = {
}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface SpedizioniProps {
    protocol: IProtocol
    forceSpedizioniRefresh: boolean

}
type Props = SpedizioniProps & PropsFromRedux

export interface SpedizioniState {
    loading: boolean
    loadingSpedizione: number
    spedizioniGroupedList: { spedizioneId: number, items: any[], groups: IGroup[] }[]
    columns: IColumn[]
    groupProps: IGroupRenderProps
}

class Spedizioni extends React.Component<Props, SpedizioniState> {

    cancelTokenSources = {};

    state: SpedizioniState = {
        loading: false,
        loadingSpedizione: 0,
        spedizioniGroupedList: [],
        columns: [

            {
                key: "info",
                name: "Destinatari",
                fieldName: "info",
                minWidth: 300,
                onRender: (item) => this.renderDestinatarioStatoData(item)
            },
            {
                key: "download",
                name: "Download",
                fieldName: "download",
                minWidth: 300,
                onRender: (item) => this.renderDownloadIcon(item)
            }],
        groupProps: {
            isAllGroupsCollapsed: true,
            onRenderHeader: (props?: IGroupHeaderProps): JSX.Element => {

                const toggleCollapse = (): void => {
                    let spedizione = props?.group?.data as IProtocolDispatch;
                    if (props?.group?.isCollapsed) {
                        if (this.cancelTokenSources[pecmailService.getStatiRicevuteByMailId.name] === undefined) {
                            this.getStatiRicevute(spedizione);
                            props!.onToggleCollapse!(props!.group!);
                        }
                    } else if (!props?.group?.isCollapsed) {
                        this.cancelTokenSources[pecmailService.getStatiRicevuteByMailId.name]?.cancel("Request annullata");

                        props!.onToggleCollapse!(props!.group!);
                    }

                };
                return (
                    <GroupHeader
                        onRenderTitle={this.onRenderTitle}
                        expandButtonProps={{
                            onClick: toggleCollapse
                        }}
                        {...props}
                        className={`${classNames.padding} ${classNames.headerMargins}`} />
                )
            }
        }
    }

    componentDidMount() {
        if (this.props.currentAoo && this.props.protocol) {
            this.getSpedizioni();
        }
    }

    componentDidUpdate(oldProps: Props) {
        if (oldProps.forceSpedizioniRefresh !== this.props.forceSpedizioniRefresh
            || oldProps.currentAoo?.id !== this.props.currentAoo?.id
            || oldProps.protocol !== this.props.protocol) {
            if (this.props.currentAoo && this.props.protocol) {
                this.getSpedizioni();
            }
        }
    }
    componentWillUnmount = () => {
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }
    }

    onRenderTitle = (props?: IGroupHeaderProps): JSX.Element => {

        let spedizione = props?.group?.data as IProtocolDispatch;

        let statoRicevutaIconProp: FontAwesomeIconProps | undefined = undefined;

        switch (spedizione.status) {
            case ProtocolDispatchEF_Status.Completata:
                statoRicevutaIconProp = {
                    className: classNames.statoColorGreen,
                    icon: { prefix: 'fas', iconName: 'circle-check' },
                    style: { marginRight: "5px" }
                }
                break;
            case ProtocolDispatchEF_Status.Undefined:
            case ProtocolDispatchEF_Status.DaInviare:
            case ProtocolDispatchEF_Status.InAttesa:
                statoRicevutaIconProp = {
                    className: classNames.statoColorYellow,
                    icon: { prefix: 'fas', iconName: 'clock' },
                    style: { marginRight: "5px" }
                }
                break;
            case ProtocolDispatchEF_Status.Errore:
            case ProtocolDispatchEF_Status.NonAccettata:
            case ProtocolDispatchEF_Status.CompletataConErrori:
                statoRicevutaIconProp = {
                    className: classNames.statoColorRed,
                    icon: { prefix: 'fas', iconName: 'circle-exclamation' },
                    style: { marginRight: "5px" }
                }
                break;

        }
        const item: IActivityItemProps = {
            styles: activityItemStyles,
            activityDescription: [
                //<div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                <div className={`flex  align-items-center justify-content-start`}>

                    <TooltipHost content={`${ProtocolDispatchEF_Status_Label.get(spedizione.status)}`}>
                        <FontAwesomeIcon {...statoRicevutaIconProp} />
                    </TooltipHost>
                    <span className={classNames.overflow}>
                        <TooltipHost content={spedizione.to}>
                            <span key={"mailbox_" + spedizione.id} style={{ fontWeight: "bold" }}>{spedizione.to}</span>
                        </TooltipHost>
                    </span>
                </div>
            ],
            timeStamp: [
                <div className={classNames.overflow}>
                    <TooltipHost content={spedizione.subject}>
                        <span key={"oggetto_" + spedizione.id}>{spedizione.subject} - </span>
                    </TooltipHost>
                    <TooltipHost content={Utilities.FormatDate(spedizione.date, false)}>
                        <span key={"data_" + spedizione.id}>{Utilities.FormatDate(spedizione.date, false)}</span>
                    </TooltipHost>
                </div>
            ]
        }
        return (
            <ActivityItem {...item} />
        )
    }



    // metodi per ottenere tutte le spedizioni
    getSpedizioni = () => {
        this.setState({ loading: true });
        protocolDispatchesService.getProtocolDispatches(this.props.currentAoo!.id, this.props.protocol.protocolId!, this.props.currentUor?.id)
            .then(response => {
                let spedizioniList = this.remapSpedizioni(response);
                this.setState({ loading: false, spedizioniGroupedList: spedizioniList });
            })
            .catch(error => {
                if (!error.isErrorShown) {
                    toastRef.current?.show({
                        severity: 'error',
                        summary: "Attenzione",
                        detail: 'Non è stato possibile recuperare le spedizioni',
                        life: 5000
                    });
                }
            })

    }

    remapSpedizioni = (response: IProtocolDispatch[]) => {

        let mapping = response.map(
            (spedizione) => {
                return {
                    spedizioneId: spedizione.id,
                    items: [
                        {
                            placeholder: "Nessuna ricevuta ancora dispondibile",
                            spedizioneId: spedizione.id,

                        }
                    ],
                    groups: [
                        {
                            key: spedizione.id.toString(),
                            name: "Group Root",
                            startIndex: 0,
                            count: 1,
                            data: spedizione,
                            level: 0,
                            isCollapsed: true

                        } as IGroup]
                }
            }
        );

        return mapping;
    }


    // metodi per ottenere gli stati della mail
    getStatiRicevute = (spedizione: IProtocolDispatch) => {

        let newSpedizioneGroupedList = [...this.state.spedizioniGroupedList];
        // trovo l'indice della spedizione da aggiornare con sottogruppi
        let newSpedizioneIndex = newSpedizioneGroupedList.findIndex(s => s.spedizioneId === spedizione.id);
        let newSpedizione = { ...newSpedizioneGroupedList[newSpedizioneIndex] };
        newSpedizione!.items = [
            {
                placeholder: "Nessuna ricevuta ancora dispondibile",
                spedizioneId: spedizione.id,

            }];
        newSpedizioneGroupedList[newSpedizioneIndex] = { ...newSpedizione };
        this.setState({ loadingSpedizione: spedizione.id, spedizioniGroupedList: newSpedizioneGroupedList });
        this.cancelTokenSources[pecmailService.getStatiRicevuteByMailId.name] = axios.CancelToken.source();

        pecmailService.getStatiRicevuteByMailId(this.props.currentAoo!.id, this.props.currentUor?.id!, spedizione.mailbox, spedizione.pecMailId, this.cancelTokenSources[pecmailService.getStatiRicevuteByMailId.name].token)
            .then(response => {
                let stati: IStatoRicevutaItem[] = [];


                let statiRemap: IStatoRicevutaItem[] = this.remapAndOrderStati(response, spedizione);
                if (statiRemap.length > 0) {
                    stati = [...stati.concat(statiRemap)];
                }

                //copio la lista di spedizioni
                let newSpedizioneGroupedList = [... this.state.spedizioniGroupedList];
                // trovo l'indice della spedizione da aggiornare con sottogruppi
                let newSpedizioneIndex = newSpedizioneGroupedList.findIndex(s => s.spedizioneId === spedizione.id);
                let newSpedizione = { ...newSpedizioneGroupedList[newSpedizioneIndex] };

                if (stati.length > 0) {
                    newSpedizione!.items = [...stati];
                    let group = { ...newSpedizione.groups[0] }
                    group = { ...group, count: stati.length };
                    newSpedizione.groups[0] = group;

                }
                else {
                    newSpedizione!.items = [
                        {
                            placeholder: "Nessuna ricevuta ancora dispondibile",
                            spedizioneId: spedizione.id,

                        }];

                }





                newSpedizioneGroupedList[newSpedizioneIndex] = { ...newSpedizione };
                //aggiorno lo stato
                this.setState({ loadingSpedizione: 0, spedizioniGroupedList: newSpedizioneGroupedList });





                delete this.cancelTokenSources[pecmailService.getStatiRicevuteByMailId.name];

            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    console.log(error.message);
                }
                else if (!error.isErrorShown) {
                    toastRef.current?.show({
                        severity: 'error',
                        summary: "Attenzione",
                        detail: 'Non è stato possibile recuperare gli stati di invio',
                        life: 5000
                    });
                }
                this.setState({ loadingSpedizione: 0 });
                delete this.cancelTokenSources[pecmailService.getStatiRicevuteByMailId.name];

            })
    }

    remapAndOrderStati = (statiRicevute: IStatoRicevutaPecMail[], spedizione: IProtocolDispatch): IStatoRicevutaItem[] => {
        let accettazione = statiRicevute.find(s => s.tipoRicevuta === TipoRicevutaEnum.Accettazione);
        let destinatariEsterni = statiRicevute.filter(s => s.tipoRicevuta === TipoRicevutaEnum.Destinatario && s.tipoDestinatario === TipoDestinatarioEnum.Esterno);
        let destinatariCertificati = statiRicevute.filter(s => s.tipoRicevuta === TipoRicevutaEnum.Destinatario && s.tipoDestinatario === TipoDestinatarioEnum.Certificato);
        if (accettazione && accettazione.nomeFile) {
            //per i destinatari esterni uso come dataRicevuta quella dell'accettazione se c'è (quindi se c'è il nomeFile)
            destinatariEsterni.forEach(dest => {
                dest.dataRicevuta = accettazione!.dataRicevuta;
            });
        }
        let informativi = statiRicevute.filter(s => s.tipoRicevuta === TipoRicevutaEnum.Informativo);
        let statiRicevuteOrdered: IStatoRicevutaPecMail[] = [];
        if (accettazione) {
            statiRicevuteOrdered = [accettazione!, ...destinatariEsterni, ...destinatariCertificati, ...informativi];

        }
        else {
            statiRicevuteOrdered = [...destinatariEsterni, ...destinatariCertificati, ...informativi];
        }
        let statiRicevuteItems = statiRicevuteOrdered.map(
            (statoRicevuta) => {
                return {
                    ...statoRicevuta,
                    mailId: spedizione.pecMailId,
                    mailbox: spedizione.mailbox,
                    spedizioneId: spedizione.id
                }
            }
        );
        return statiRicevuteItems;
    }

    // metodi per onRender colonne
    renderDestinatarioStatoData = (item: IStatoRicevutaItem) => {

        if (item.spedizioneId === this.state.loadingSpedizione) {
            return (
                <Shimmer />
            )
        }
        else if (item.placeholder) {
            return (
                <TooltipHost content={item.placeholder}>
                    <div className={classNames.overflow}>{item.placeholder}</div>
                </TooltipHost>
            )
        }
        else if (item.tipoRicevuta === TipoRicevutaEnum.Accettazione) {
            return (
                <>
                    <TooltipHost content={"Accettazione"}>
                        <div className={classNames.accettazione}>Accettazione</div>
                    </TooltipHost>
                    <span className={classNames.overflow}>
                        in data {Utilities.FormatDate(item.dataRicevuta, false)}
                    </span>
                </>
            )
        }
        else {
            let statoColorCss = statoRicevutaIconTooltipMap[item.stato].statoColorCss;
            let statoLabel = statoRicevutaIconTooltipMap[item.stato].statoRicevutaLabel;
            return (
                <>
                    <div className={`flex  align-items-center justify-content-start`}>
                        <TooltipHost content={tipoDestinatarioIconTooltipMap[item.tipoDestinatario].tooltip}>
                            <FontAwesomeIcon {...tipoDestinatarioIconTooltipMap[item.tipoDestinatario].iconProps} />
                        </TooltipHost>
                        <TooltipHost content={item.destinatario}>
                            <div className={classNames.overflow}>{item.destinatario}</div>
                        </TooltipHost>
                    </div>
                    <TooltipHost content={`${statoLabel} in data ${Utilities.FormatDate(item.dataRicevuta, false)}`}>
                        <span className={classNames.overflow}>
                            <span className={statoColorCss} >{statoLabel}</span> in data {Utilities.FormatDate(item.dataRicevuta, false)}
                        </span>
                    </TooltipHost>
                </>
            );
        }
    }

    renderDownloadIcon = (item: any) => {
        return (
            <>
                {item.nomeFile &&
                    <span>
                        <TooltipHost content="Download File" >
                            <IconButton
                                iconProps={downloadIcon}
                                aria-label="Download"
                                onClick={() => this.downloadFile(item)}
                            />
                        </TooltipHost>
                    </span>
                }
            </>
        );
    }


    // gestione render delle celle 
    onRenderCell = (nestingDepth?: number, item?: any, itemIndex?: number, group?: IGroup): React.ReactNode => {

        return (
            <DetailsRow
                columns={this.state.columns}
                groupNestingDepth={nestingDepth}
                item={item}
                itemIndex={itemIndex!}
                selectionMode={SelectionMode.none}
                group={group}
                styles={detailsRowStyles}
            />
        );

    }

    //metodo per scaricale il file 
    downloadFile = (item: IStatoRicevutaItem) => {
        toastRef.current?.show({
            severity: 'info',
            summary: "Informazione",
            detail: 'Download in corso',
            life: 5000
        });

        pecmailService.getBase64ForReceipt(this.props.currentAoo!.id, this.props.currentUor?.id!, item.mailbox, item.mailId, item.id)
            .then(response => {
                Utilities.SaveFileFromBase64(response, item.nomeFile);
                toastRef.current?.show({
                    severity: 'info',
                    summary: "Informazione",
                    detail: 'Download completato',
                    life: 5000
                });

            })
            .catch(error => {
                if (!error.isErrorShown) {
                    toastRef.current?.show({
                        severity: 'error',
                        summary: "Attenzione",
                        detail: 'Non è stato possibile scaricare la ricevuta',
                        life: 5000
                    });
                }
                this.setState({ loadingSpedizione: 0 });
                delete this.cancelTokenSources[pecmailService.getStatiRicevuteByMailId.name];

            })
    }

    render() {
        return (
            <div className={`flex flex-column position-relative`}>
                <CircleLoader loaderClass='loader-large' loading={this.state.loading} />
                <div className={'my-scroll-div position-relative'}>
                    <div className={`my-component-content`}>

                        {this.state.spedizioniGroupedList.length > 0 ?
                            this.state.spedizioniGroupedList.map(
                                (spedizione, index) => (

                                    <GroupedList
                                        key={"spedizione_" + spedizione.spedizioneId}
                                        items={spedizione.items}
                                        onRenderCell={this.onRenderCell}
                                        selectionMode={SelectionMode.none}
                                        groups={spedizione.groups}
                                        groupProps={this.state.groupProps}

                                    />
                                )
                            ) :
                            <div style={{ marginLeft: '31px' }}>
                                <Text> Non ci sono spedizioni </Text>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default connector(Spedizioni);
